import { UserType } from '../gql/graphql';
import type { PermissionUtils } from '../hooks';

export function getPermissionFunctions(usersPermissions: Set<string>) {
  return {
    hasPermission: (permission: string) => usersPermissions.has(permission),
    hasAtLeastOnePermission: (permissions: Array<string>) =>
      permissions.some((permission) => usersPermissions.has(permission ?? '')),
    hasAllPermissions: (permissions: Array<string>) =>
      permissions.every((permission) => usersPermissions.has(permission ?? '')),
  };
}

export const isStaffUser = (
  permission: Pick<PermissionUtils, 'userType' | 'tenant'>,
) => {
  const { userType, tenant } = permission;
  return (
    !!userType &&
    ([UserType.Admin, UserType.Teacher].includes(userType) ||
      (UserType.Tyro === userType && tenant !== -32))
  );
};

export const isTyroTenantAndUser = (
  permission: Pick<PermissionUtils, 'userType' | 'tenant'>,
) => {
  const { userType, tenant } = permission;
  return !!userType && UserType.Tyro === userType && tenant === -32;
};

export const isTyroUser = (permission: Pick<PermissionUtils, 'userType'>) => {
  const { userType } = permission;
  return !!userType && userType === UserType.Tyro;
};

export const isStudent = (permission: Pick<PermissionUtils, 'userType'>) => {
  const { userType } = permission;
  return !!userType && userType === UserType.Student;
};

export const isContact = (permission: Pick<PermissionUtils, 'userType'>) => {
  const { userType } = permission;
  return !!userType && userType === UserType.Contact;
};
